import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppNotificationsService } from '@deltager/organizers/admin/core/services/app-notifications.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { catchError, filter, finalize, map, take, tap } from 'rxjs/operators';
import { UserService } from '@deltager/organizers/admin/core/services/user.service';
import { OrganizerValidationService } from '@deltager/organizers/admin/core/services/organizer-validation.service';
import { SpinnerOverlayService } from '@deltager/organizers/admin/shared/spinner-overlay/spinner-overlay.service';
import { ConfirmDialogComponent } from '@deltager/organizers/admin/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgIf } from '@angular/common';
import { ConfirmDialogData } from '@deltager/organizers/admin/shared/models/confirm-dialog-data.model';
import { BankIdButtonComponent } from '../../../shared/components/bank-id-button/bank-id-button.component';

@Component({
  selector: 'app-organizer-validation',
  templateUrl: './organizer-validation.component.html',
  styleUrls: [],
  standalone: true,
  imports: [TranslateModule, NgIf, BankIdButtonComponent],
})
export class OrganizerValidationComponent implements OnInit {
  @Input({ required: true }) shownInEventSetup: boolean;
  @Input({ required: true }) organizerId: number;
  @Output() validationCompleted = new EventEmitter<boolean>();
  @Output() shouldMoveToValidationUrl = new EventEmitter<string>();

  isWorking = false;

  constructor(
    private userdataService: UserService,
    private spinnerService: SpinnerOverlayService,
    private validationService: OrganizerValidationService,
    private appNotificationService: AppNotificationsService,
    private translate: TranslateService,
    private dialog: MatDialog,
  ) {
    spinnerService.spinnerState
      .pipe(
        takeUntilDestroyed(),
        tap(state => {
          this.isWorking = state.visible;
        }),
      )
      .subscribe(_ => {});
  }

  ngOnInit(): void {}

  startValidation() {
    if (!this.shownInEventSetup) {
      this.validateOrganizer();
      return;
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '550px',
      panelClass: 'dialog-rounded-shadow',
      data: {
        title: this.translate.instant('organizer.validation.goto.identity.header'),
        content: this.translate.instant('organizer.validation.goto.identity.text'),
        submitBtn: 'global.continue',
        cancelBtn: 'global.cancel',
      } as ConfirmDialogData,
    });

    dialogRef
      .afterClosed()
      .pipe(filter(r => !!r))
      .subscribe(result => {
        this.validateOrganizer();
      });
  }

  validateOrganizer() {
    this.spinnerService.show();

    const callbackUrl = window.location.href;
    this.validationService
      .getBankIdValidationUrl(this.userdataService.OrganizerId, callbackUrl)
      .pipe(
        take(1),
        map(res => {
          if (res != null) {
            this.shouldMoveToValidationUrl.emit(res);
          } else {
            this.showError();
          }
        }),
        catchError(err => {
          this.showError();
          return err;
        }),
        finalize(() => {
          this.spinnerService.hide();
        }),
      )
      .subscribe();
  }

  showError() {
    this.appNotificationService.sendError({
      title: this.translate.instant('validation.validate_identity_status_failed'),
    });
  }
}
